import axios from 'axios';
import store from '@/store/index.js'

let isRefreshing = false
let requests = [] // 用来存储等待的请求

const service = axios.create({
  timeout: 30 * 1000,
  baseURL: 'https://common.eastfair.cn'
})

// 请求拦截器
service.interceptors.request.use(config => {
  if (!!store.getters.public_token && config.url !== '/api/blade-auth/oauth/token') {
    config.headers["Blade-Auth"] = store.getters.public_token
  }
  if (config.url !== '/api/blade-auth/oauth/token') {
    config.headers["Authorization"] = 'Basic c2FiZXI6c2FiZXJfc2VjcmV0'
  }
  config.headers["Content-Type"] = "application/json"
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use((response) => {
  return response
}, async (error) => {
  const { response, config } = error
  if (response && response.status === 401) {
    const newToken = await store.dispatch('getPublicServerToken')
    config.headers['Blade-Auth'] = newToken
    return await service(config) // 返回结果
  } else {
    return Promise.reject(error)
  }
})

// 登录公共服务
export function loginPublicServer(params = {
    grant_type: 'client_credentials',
    client_secret: '5aae13583ecc31c2c339535af54dc7bb',
    client_id: 'a17358ac5a27e36ebf7ad1c41dc49512'
  }) {
  return service({
    url: '/api/blade-auth/oauth/token',
    method: 'post',
    params: params
  })
}

// 获取配置
export function getSystemConfig(data) {
  return service({
    url: "/api/common-service-admin/blade-commonAiApp/commonAiApp/list/bot",
    method: "get",
    params: {
      ...data,
      current: 1,
      size: 1
    }
  })
}